import {
  ActiveStatus,
  Cause,
  Frequency,
  Issue,
  Machine,
  Template,
  YesOrNo,
} from '../types';

export const issues: Issue[] = [
  {
    issueID: 'issue1',
    name: 'Issue1',
    labels: [],
    tools: [],
    qualification: '',
    description: 'Issue1 description',
    activeStatus: ActiveStatus.ACTIVE,
    isSuggestion: YesOrNo.NO,
  },
  {
    issueID: 'issue2',
    name: 'Issue2',
    labels: [],
    tools: [],
    qualification: '',
    description: 'Issue2 description',
    activeStatus: ActiveStatus.ACTIVE,
    isSuggestion: YesOrNo.NO,
  },
];

export const causes: Cause[] = [
  {
    causeID: 'cause1',
    name: 'Cause1',
    labels: [],
    tools: [],
    qualification: '',
    description: 'Issue1 description',
    activeStatus: ActiveStatus.ACTIVE,
    isSuggestion: YesOrNo.NO,
  },
  {
    causeID: 'cause2',
    name: 'Cause2',
    labels: [],
    tools: [],
    qualification: '',
    description: 'Cause2 description',
    activeStatus: ActiveStatus.ACTIVE,
    isSuggestion: YesOrNo.NO,
  },
];

export const machines: Machine[] = [
  {
    machineID: '1',
    name: 'Machine 1',
    alias: 'Machine 1',
    location: 'Machine 1',
    serviceNumber: 'Machine 1',
    templateID: 'template1',
    type: 'type 1',
    manufacturer: 'manufacturer1',
    serialNumber: 'BECYRTY7UUI123',
    constructionDate: '',
    acceptanceDate: '',
    image: '/machine.png',
    documents: [],
  },
  {
    machineID: '2',
    name: 'Machine 2',
    alias: 'Machine 2',
    location: 'Machine 2',
    serviceNumber: 'Machine 2',
    templateID: 'template1',
    type: 'type 2',
    manufacturer: 'manufacturer 2',
    serialNumber: 'BECYRTY7UUI2ED',
    constructionDate: '',
    acceptanceDate: '',
    image: '/machine.png',
    documents: [],
  },
  {
    machineID: '3',
    name: 'Machine 3',
    alias: 'Machine 3',
    location: 'Machine 3',
    serviceNumber: 'Machine 3',
    templateID: 'template1',
    type: 'type 3',
    manufacturer: 'manufacturer 3',
    serialNumber: 'BECYRTY7UUI',
    constructionDate: '',
    acceptanceDate: '',
    image: '/machine.png',
    documents: [],
  },
];

export const templates: Template[] = [
  {
    templateID: '1',
    name: 'Template 1',
    type: 'Type 1',
    machines: [machines[1]],
    issues: [issues[0], issues[1]],
    causes: [causes[0], causes[1]],
    solutionGrid: [],
  },
  {
    templateID: '2',
    name: 'Template 2',
    type: 'Type 2',
    machines: [machines[0], machines[2]],
    issues: [issues[0], issues[1]],
    causes: [causes[0], causes[1]],
    solutionGrid: [],
  },
  {
    templateID: '3',
    name: 'Template 3',
    type: 'Type 2',
    machines: [machines[0], machines[1], machines[2]],
    issues: [issues[0], issues[1]],
    causes: [causes[0], causes[1]],
    solutionGrid: [],
  },
];
